const {createTheme} = require('@material-ui/core/styles');

export const constructTheme = (primaryColor, alteredPrimaryColor, overrides) => createTheme({
  palette: {
    primary: {
      main: primaryColor
    },
    error: {
      main: '#fb3958' // Same value as in colors.scss
    }
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        // Same values as in tooltip.scss
        backgroundColor: 'rgba(38, 55, 68, 0.95)',
        color: '#fff',
        fontSize: '1.4rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
      }
    },
    MuiOutlinedInput: {
      root: {
        '&:hover $notchedOutline': {
          borderColor: alteredPrimaryColor
        }
      }
    },
    MuiSkeleton: {
      root: {
        backgroundColor: '#eff4f8'
      },
      rect: {
        borderRadius: 10
      }
    },
    MuiFab: {
      root: {
        position: 'fixed',
        bottom: 30,
        right: 30,
        zIndex: 13
      },
      colorInherit: {
        backgroundColor: alteredPrimaryColor,
        color: '#fff',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: primaryColor
        }
      }
    },
    ...overrides
  },
  props: {
    MuiFormControl: {
      fullWidth: true,
      variant: 'outlined'
    },
    MuiTextField: {
      fullWidth: true,
      variant: 'outlined',
      className: 'custom-text-field'
    },
    MuiCheckbox: {
      color: 'primary'
    },
    MuiSwitch: {
      color: 'primary'
    },
    MuiExpansionPanelSummary: {
      className: 'clickable'
    },
    MuiFab: {
      disableRipple: true
    }
  },
  typography: {
    htmlFontSize: 10,
    useNextVariants: true,
    fontFamily: [
      'Montserrat'
    ].join(',')
  }
});

export default constructTheme;
